import React, { useState, useEffect } from "react";
import Header from "../header/header";
import Footer from "../../components/footer";
import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import Img from "../../assets/images/media/media-67.png";

const Privacycontent = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" && isFullscreen) {
        setIsFullscreen(false);
      }
    };
    // Add event listener when component mounts
    document.addEventListener("keydown", handleEscapeKey);

    // Cleanup event listener when component unmounts
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [isFullscreen]);

  const [languageData, setLanguageData] = useState(null);

  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;

    if (cookieLang) {
      import(`../../lang/privacy/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  return (
    <>
      <div
        className={`row justify-content-center ${isFullscreen ? "fullscreen-overlay" : ""}`}
        style={{
          position: isFullscreen ? "fixed" : "static",
          top: isFullscreen ? 0 : "auto",
          left: isFullscreen ? 0 : "auto",
          width: isFullscreen ? "100%" : "auto",
          height: isFullscreen ? "100%" : "auto",
          zIndex: isFullscreen ? 1000 : "auto",
          backgroundColor: isFullscreen ? "white" : "transparent",
          overflow: isFullscreen ? "auto" : "visible",
        }}
      >
        <div className="col-xl-12">
          <div className="card custom-card overflow-hidden">
            <div className="card-body p-0">
              <div className="p-4 terms-heading-cover d-flex align-items-center text-primary bg-primary-transparent h5 fw-semibold mb-0">
                <span className="avatar avatar-md me-3">
                  <img src={Img} alt="" />
                </span>
                {languageData.Terms_and_Conditions}
                <a
                  href="javascript:void(0);"
                  onClick={toggleFullscreen}
                  className="ms-auto text-primary"
                  title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                >
                  <i
                    className={`ri-${isFullscreen ? "fullscreen-exit-line" : "fullscreen-line"}`}
                  ></i>
                </a>
              </div>
              <div
                className="p-4 text-muted terms-conditions"
                id="terms-scroll"
                style={{
                  maxHeight: isFullscreen ? "calc(100vh - 100px)" : "none",
                  overflowY: isFullscreen ? "auto" : "visible",
                  textAlign: "left",
                }}
              >
                <div className="mb-5">
                  <p className="mb-3 op-7">
                    <span className="fw-bold text-default op-8">
                      {languageData.If_you_stay_in}
                    </span>{" "}
                    {languageData.the_Velvet}{" "}
                    <a className="text-primary" href="javascript:void(0);">
                      <u>{languageData.Terms_and_Conditions}</u>
                    </a>{" "}
                    {languageData.consists_of_below}{" "}
                    <a className="text-primary" href="javascript:void(0);">
                      <u>{languageData.User_Agreements}</u>
                    </a>{" "}
                    {languageData.incorporated}
                  </p>
                </div>
                <h6 className="fw-bold pb-3 text-default op-7">
                  <span className="terms-heading">
                    {languageData.Terms_Services}:
                  </span>
                </h6>
                <div className="mb-4">
                  <p className="fw-semibold text-muted mb-2 fs-14">
                    1 - {languageData.Lorem_ipsum}
                  </p>
                  <p className="op-7 mb-0">{languageData.Note_that}</p>
                </div>
                <div className="mb-4">
                  <p className="fw-semibold text-muted mb-2 fs-14">
                    2 - {languageData.Consectetur_adipisicing}
                  </p>
                  <p className="op-7 mb-2">{languageData.While_they}</p>
                  <p className="op-7">{languageData.It_also}</p>
                </div>
                <div className="mb-4">
                  <p className="fw-semibold text-muted mb-2 fs-14">
                    3 - {languageData.There_are_many_variations}
                  </p>
                  <p className="op-7">{languageData.Limitation}</p>
                </div>
                <div className="mb-4">
                  <p className="fw-semibold text-muted mb-2 fs-14">
                    4 - {languageData.If_you_allow}
                  </p>
                  <p className="op-7 mb-2">
                    {languageData.If_you_allow_your_users}
                  </p>
                  <p className="op-7 mb-2">{languageData.In_this_clause}</p>
                </div>
                <div className="mb-0">
                  <p className="fw-semibold text-muted mb-2 fs-14">
                    5 - {languageData.You_could}
                  </p>
                  <p className="op-7 mb-2">{languageData.You_could_also}</p>
                  <p className="op-7 mb-0">{languageData.From_a_business}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacycontent;
